import React, { useEffect, useState } from 'react';
import GlobalDialog from '../../mui/Dialogue/GlobalDialog';
import { AddButton, CancelButton, EditButton, SubmitButton, UpdateButton } from '../../mui/Buttons/Buttons';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { Box, Stack, TextField } from '@mui/material';
import GlobalSelectField from '../../mui/GlobalSelectField';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { getLeadsForDeo, postLeadForDeoSkillx, updateDeoLeadsforskillx } from '../../../redux/features/deoSlice';
import { savePaginationData } from '../../../redux/features/globalDatagridSlice';
export const preferredTypes = [
  { id: 1, name: 'Online' },
  { id: 2, name: 'Offline' },
];

export const genders = [
  { id: 1, name: 'Male' },
  { id: 2, name: 'Female' },
];

const SkillxAddorEditDeoLeads = ({ row, dispatchParams,setAlertContent,setAlertOpen  }) => {
  const { loading } = useSelector((store) => store.deo);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const initialValues = {
    leadName: row ? row.lead_name : '',
    age: row ? row.age : '',
    gender: row ? (row.gender == 'Male' ? 1 : 2) : '',
    preferredType: row ? row.lead_class_mode : '',
    courseId: row ? row.lead_preffered_course : '',
    clubName: row ? row.lead_preffered_club : '',
    parentName: row ? row.lead_father_name : '',
    countryCode: row ? row.lead_country_code : '',
    contactNumber: row ? row.lead_mob_no : '',
    whatsappNumber: row ? row.lead_whatsapp_no : '',
    remarks: row ? row.lead_remarks : '',
    place: row ? row.lead_place : '',
    email: row ? row.lead_email_id : '',
  };
  const schema = Yup.object({
    leadName: Yup.string().required('Lead Name is required'),
    age: Yup.number().required('Age is required'),
    gender: Yup.mixed().required('Gender is required'),
    preferredType: Yup.number().required('Preferred Type is required'),
    countryCode: Yup.string().required('Country Code is required'),
    contactNumber: Yup.number().required('Contact Number is required'),
    whatsappNumber: Yup.number().required('Whatsapp Number is required'),
    remarks: Yup.string().required('Remarks is required'),
    place: Yup.string().required('Place is required'),
    email: Yup.string().email().required('Email is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = [
        {
          lead_name: values.leadName,
          lead_country_code: values.countryCode,
          lead_mob_no: values.contactNumber,
          age: values.age,
          lead_class_mode: values.preferredType,
          gender: values.gender == 1 ? 'Male' : 'Female',
          lead_whatsapp_no: values.whatsappNumber,
          lead_remarks: values.remarks,
          lead_place: values.place,
          lead_email_id: values.email,
        },
      ];
      if (row) {
        data[0] = { ...data[0], lead_id: row.lead_id };
        dispatch(updateDeoLeadsforskillx({ data })).then((res) => {
          if (res.payload.status === 'error') {
            enqueueSnackbar(res.payload.message, {
              variant: 'error',
            });
          } else if (res.payload.status === 'success') {
            handleCancel();
            dispatch(getLeadsForDeo(dispatchParams));
            dispatch(savePaginationData({ ...paginationData, openAnchor: false }));
            enqueueSnackbar(res.payload.message, {
              variant: 'success',
            });
          }
        });
      } else {
        dispatch(postLeadForDeoSkillx({ data })).then((res) => {
          if (res.payload.status === 'error') {
            enqueueSnackbar(res.payload.message, {
              variant: 'error',
            });
          } else if (res.payload.status === 'success') {
            dispatch(getLeadsForDeo(dispatchParams));
            handleCancel();
            // enqueueSnackbar(res.payload.message, {
            //   variant: "success",
            // });
            setAlertContent({
              title: 'Success',
              message: res.payload.message,
              data: res.payload.data,
            });
            setAlertOpen(true);
          }
        });
      }
    },
  });

  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  const handleChange = (event, option) => {
    const fieldName = event.target?.id.split('-')[0];
    formik.setFieldValue(fieldName, option.id);
  };
  return (
    <GlobalDialog
      maxWidth={'sm'}
      fullWidth
      title={'Action'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          {row ? (
            <EditButton sx={{ ml: 2 }} disabled={false} size="small" variant={'outlined'} action={() => setOpen(true)}>
              Edit Lead
            </EditButton>
          ) : (
            <AddButton size={'small'} action={() => setOpen(true)}>
              Add Lead
            </AddButton>
          )}
        </>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Stack gap={2}>
                <Box>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="leadName"
                    label="Lead Name"
                    name="leadName"
                    value={formik.values.leadName}
                    onChange={formik.handleChange}
                    error={formik.touched.leadName && Boolean(formik.errors.leadName)}
                    helperText={formik.touched.leadName && formik.errors.leadName}
                  />
                </Box>
                <Box>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="age"
                    type="number"
                    label="Age"
                    name="age"
                    value={formik.values.age}
                    onChange={formik.handleChange}
                    error={formik.touched.age && Boolean(formik.errors.age)}
                    helperText={formik.touched.age && formik.errors.age}
                    onWheel={(e) => e.target.blur()}
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      onWheel: (e) => e.target.blur(),
                    }}
                  />
                </Box>
                <Box>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="place"
                    type="text"
                    label="Place"
                    name="place"
                    value={formik.values.place}
                    onChange={formik.handleChange}
                    error={formik.touched.place && Boolean(formik.errors.place)}
                    helperText={formik.touched.place && formik.errors.place}
                  />
                </Box>
                <Box>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="email"
                    type="email"
                    label="Email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </Box>
                <Box>
                  <GlobalSelectField
                    options={{
                      formik: formik,
                      label: 'Gender',
                      name: 'gender',
                      data: genders,
                      keys: {
                        id: 'id',
                        value: 'name',
                      },
                      sx: {
                        width: '100%',
                      },
                    }}
                  />
                </Box>

                <Box>
                  <GlobalSelectField
                    options={{
                      formik: formik,
                      label: 'Preferred Type',
                      name: 'preferredType',
                      data: preferredTypes,
                      keys: {
                        id: 'id',
                        value: 'name',
                      },
                      sx: {
                        width: '100%',
                      },
                    }}
                  />
                </Box>
                <Stack direction={{ xs: 'column', md: 'row' }} gap={1}>
                  <Box sx={{ flex: 0.5 }}>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      type="number"
                      id="countryCode"
                      label="Country Code"
                      name="countryCode"
                      value={formik.values.countryCode}
                      onChange={formik.handleChange}
                      error={formik.touched.countryCode && Boolean(formik.errors.countryCode)}
                      helperText={formik.touched.countryCode && formik.errors.countryCode}
                      onWheel={(e) => e.target.blur()}
                      inputProps={{
                        inputMode: 'numeric',
                        pattern: '[0-9]*',
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <TextField
                      type="number"
                      autoComplete="off"
                      fullWidth
                      id="contactNumber"
                      label="Contact Number"
                      name="contactNumber"
                      value={formik.values.contactNumber}
                      onChange={formik.handleChange}
                      error={formik.touched.contactNumber && Boolean(formik.errors.contactNumber)}
                      helperText={formik.touched.contactNumber && formik.errors.contactNumber}
                      onWheel={(e) => e.target.blur()}
                      inputProps={{
                        inputMode: 'numeric',
                        pattern: '[0-9]*',
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <TextField
                      autoComplete="off"
                      fullWidth
                      type="number"
                      id="whatsappNumber"
                      label="Whatsapp Number"
                      name="whatsappNumber"
                      value={formik.values.whatsappNumber}
                      onChange={formik.handleChange}
                      error={formik.touched.whatsappNumber && Boolean(formik.errors.whatsappNumber)}
                      helperText={formik.touched.whatsappNumber && formik.errors.whatsappNumber}
                      onWheel={(e) => e.target.blur()}
                      inputProps={{
                        inputMode: 'numeric',
                        pattern: '[0-9]*',
                        onWheel: (e) => e.target.blur(),
                      }}
                    />
                  </Box>
                </Stack>
                <Box sx={{ flex: 1 }}>
                  <TextField
                    fullWidth
                    multiline
                    maxRows={4}
                    variant="filled"
                    autoComplete="off"
                    id="remarks"
                    label="Remarks"
                    name="remarks"
                    value={formik.values.remarks}
                    onChange={formik.handleChange}
                    error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                    helperText={formik.touched.remarks && formik.errors.remarks}
                  />
                </Box>
              </Stack>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Stack direction={'row'} spacing={1}>
                  <CancelButton action={() => handleCancel()}>Cancel</CancelButton>
                  {row ? (
                    <UpdateButton disabled={loading} type="submit">
                      {loading ? 'Updating...' : 'Update'}
                    </UpdateButton>
                  ) : (
                    <SubmitButton disabled={loading} type="submit">
                      {loading ? 'Submiting...' : 'Submit'}
                    </SubmitButton>
                  )}
                </Stack>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default SkillxAddorEditDeoLeads;
